"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authCreateEmailPassword = authCreateEmailPassword;
exports.authDisableBiometric = authDisableBiometric;
exports.authEnableBiometric = authEnableBiometric;
exports.authForgotEmailPassword = authForgotEmailPassword;
exports.authGuestToken = authGuestToken;
exports.authNotYouRegistration = authNotYouRegistration;
exports.authRefreshToken = authRefreshToken;
exports.authResendEmailPassword = authResendEmailPassword;
exports.authResendOtp = authResendOtp;
exports.authSendOtp = authSendOtp;
exports.authSetEmailPassword = authSetEmailPassword;
exports.authUpdateEmail = authUpdateEmail;
exports.authUpdateEmailPassword = authUpdateEmailPassword;
exports.authUserLogOut = authUserLogOut;
exports.authUserRegister = authUserRegister;
exports.authVerifyBiometric = authVerifyBiometric;
exports.authVerifyEmail = authVerifyEmail;
exports.authVerifyEmailPassword = authVerifyEmailPassword;
exports.authVerifyOtp = authVerifyOtp;
exports.authVerifyUaePass = authVerifyUaePass;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function authSendOtp(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_SEND_OTP}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authVerifyOtp(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_VERIFY_OTP}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authResendOtp(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_RESEND_OTP}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authUserRegister(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_USER_REGISTER}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authUserLogOut(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_USER_LOG_OUT}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authRefreshToken(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_REFRESH_TOKEN}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authVerifyEmail(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_VERIFY_EMAIL}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authVerifyEmailPassword(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_VERIFY_EMAIL_PASSWORD}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authResendEmailPassword(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_RESEND_EMAIL_PASSWORD}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authSetEmailPassword(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_SET_EMAIL_PASSWORD}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authForgotEmailPassword(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_FORGOT_EMAIL_PASSWORD}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authUpdateEmail(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_UPDATE_EMAIL}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authVerifyUaePass(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_VERIFY_UAE_PASS}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authVerifyBiometric(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_VERIFY_BIOMETRIC}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authNotYouRegistration(requestParams) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_NOT_YOU_REGISTRATION}`;
  const options = {};
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authEnableBiometric(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_ENABLE_BIOMETRIC}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authDisableBiometric(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_DISABLE_BIOMETRIC}/${requestParams === null || requestParams === void 0 ? void 0 : requestParams.deviceID}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authGuestToken() {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_GUEST_TOKEN}`;
  const options = {};
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authUpdateEmailPassword(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_UPDATE_EMAIL_PASSWORD}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.PUT;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function authCreateEmailPassword(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_CREATE_EMAIL_PASSWORD}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}